import { defineMessages } from 'react-intl';

export const i18n: {
	pageStatus: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	pageStatus: {
		id: 'search-page.filters.names.pageStatus',
		defaultMessage: 'Status',
		description: 'Label for filtering by page status for confluence',
	},
});
